import { useContext, createContext } from 'react';

export interface FormContextValue {
  formId: string;
}

export const FormContext = createContext<FormContextValue | null>(null);

export function useFormContext(): FormContextValue {
  const ctx = useContext(FormContext);
  if (!ctx) {
    throw new Error('Form field rendered outside a FormLayoutComponent. Wrap it in a `form`.');
  }
  return ctx;
}
